/******/ (() => { // webpackBootstrap
var isDefined = customElements.get('localization-form');

if (!isDefined) {
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();

      this.thing = 0;
      this.isPanelOpen = false;

      this.elements = {
        input: this.querySelector('input[name="language_code"],input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };

      // A deferred instance renders an empty <ul> so its options do not sit in front of the LCP
      // image. Bind the option handlers after hydration instead of here, where there is nothing
      // to bind to yet.
      this.isDeferred = !!(this.elements.panel && this.elements.panel.dataset.localizationDefer);

      this.elements.button.addEventListener('click', this.togglePanel.bind(this));
      this.elements.button.addEventListener('focusout', this.handleFocusOut.bind(this));
      this.elements.panel.addEventListener('focusout', this.handleFocusOut.bind(this));
      document.addEventListener('mousedown', this.handleDocumentClick.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    handleDocumentClick(event) {
      if (!this.contains(event.target)) {
        this.hidePanel();
      }
    }

    handleFocusOut(event) {
      // Only handle focusout if the focus is moving outside the component
      if (!this.contains(event.relatedTarget)) {
        this.hidePanel();
      }
    }

    hidePanel() {
      this.isPanelOpen = false;
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    hydrate() {
      if (!this.isDeferred) return true;
      const panel = this.elements.panel;
      if (panel.children.length) return true;
      const kind = panel.dataset.localizationDefer;
      // Clone from whichever instance still carries a populated list -- the footer one, which
      // renders after the hero where its bytes cost nothing. Falling back to "any populated
      // source" rather than a fixed id means turning the footer selector off in the theme editor
      // degrades this to whatever other instance is present instead of emptying the panel.
      const source = document.querySelector('ul[data-localization-source="' + kind + '"]');
      if (!source || !source.children.length) {
        // No source anywhere: an open-but-empty picker is worse than no picker, so remove it.
        this.hidden = true;
        return false;
      }
      panel.innerHTML = source.innerHTML;
      panel.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
      return true;
    }

    showPanel() {
      if (!this.hydrate()) return;
      this.isPanelOpen = true;
      this.elements.button.setAttribute('aria-expanded', 'true');
      this.elements.panel.removeAttribute('hidden');
    }

    togglePanel(event) {
      event.preventDefault();
      event.stopPropagation();
      
      if (this.isPanelOpen) {
        this.hidePanel();
      } else {
        this.showPanel();
      }
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }
  }

  customElements.define('localization-form', LocalizationForm);
}
/******/ })()
;